import MakeNotification from "./MakeNotification";
import errorIcon from '../../img/errorTriangle.svg';

export const ErrorNotification = MakeNotification(errorIcon, 'red', 'ErrorNotification');